import { ReviewDetailsFragment } from '@sdk/gqlTypes/generatedOperations';

export const structuredData = (reviews: ReviewDetailsFragment[]): string =>
  JSON.stringify({
    '@context': 'https://schema.org/',
    '@graph': reviews.map((e, _, arr) => {
      const images = e.product?.images.map((image) => new URL(image.url));
      return {
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: e.fullName,
        },
        itemReviewed: {
          '@type': 'Product',
          brand: 'Reno',
          image: images,
          manufacturer: 'Reno sp zoo',
          name: e.product?.name ? e.product?.name : 'sliding doors',
          productID: e.product?.slug ? e.product?.slug : 'sliding-doors',
          sku: e.product?.slug ? e.product?.slug : 'sliding-doors',
        },
        datePublished: e.createdAt,
        name: e.title,
        reviewBody: e.description,
        reviewRating: {
          '@type': 'Rating',
          bestRating: arr.reduce((max, val) => {
            let sum = max;
            if (val.rating > sum) {
              sum = val.rating;
            }
            return sum;
          }, 0),
          ratingValue: e.rating,
          worstRating: arr.reduce((min, val) => {
            let sum = min;
            if (val.rating < sum) {
              sum = val.rating;
            }
            return sum;
          }, 5),
        },
      };
    }),
  });
